<template>
  <div v-if="internalValue" class="chart-config">
    <template v-if="internalValue.mode">
      <ToggleOptionsInput 
        v-if="internalValue.horizontal && internalValue.mode.value !== 'lines' && internalValue.mode.value !== 'donut'"
        v-model="internalValue.horizontal.value"
        title="chart_orientation"
        :options="toggleOptions.orientation"
      />
      <ToggleOptionsInput 
        v-if="internalValue.mode.value === 'lines'"
        v-model="internalValue.curve.value"
        title="line_apearence"
        :options="toggleOptions.lineAppearence"
      />
      <CheckboxInput
        v-if="internalValue.mode.value === 'lines'"
        v-model="showLinePoints"
        text="show_points"
        class="checkbox-points"
      />
      <ToggleOptionsInput 
        v-if="internalValue.mode.value === 'single'"
        v-model="internalValue.ItemsHelper.colorScale.value"
        title="chart_color"
        :options="toggleOptions.color"
      />
    </template>
    <div v-if="internalValue" class="legend-wrap">
      <div v-if="!internalValue.LegendBehavior.showLegend.nonEditable" class="title">{{ $t('chart_legend_title') }}</div>
      <div class="checkboxes-wrap">
        <CheckboxInput
          v-if="internalValue.AxisHelper && internalValue.AxisHelper.x && !internalValue.AxisHelper.x.showTickValues.nonEditable"
          v-model="internalValue.AxisHelper.x.showTickValues.value"
          text="chart_labels"
        />
        <CheckboxInput
          v-if="internalValue.mode && internalValue.mode.value === 'lines'"
          v-model="internalValue.showLineLabel.value"
          text="line_labels"
        />
        <CheckboxInput
          v-if="internalValue.showDatumValues && !internalValue.showDatumValues.nonEditable"
          v-model="internalValue.showDatumValues.value"
          :text="internalValue.mode && internalValue.mode.value === 'lines' ? 'line_values' : 'chart_values'"
        />
        <CheckboxInput
          v-if="internalValue.mode && internalValue.mode.value === 'donut'"
          v-model="internalValue.showLabels.value"
          text="el_labels"
        />
        <CheckboxInput
          v-if="internalValue.mode && internalValue.mode.value === 'donut'"
          v-model="specialDonutCheckbox"
          text="value_in_labels"
        />
        <CheckboxInput
          v-if="!internalValue.LegendBehavior.showLegend.nonEditable"
          v-model="internalValue.LegendBehavior.showLegend.value"
          text="chart_legend"
        />
      </div>
    </div>
    <CheckboxInput 
      v-if="internalValue.showHeatValues!==undefined"
      v-model="internalValue.showHeatValues.value"
      text="chart_heat_values"
    />
    <ToggleOptionsInput 
      v-if="internalValue.mode && internalValue.AxisHelper && !internalValue.AxisHelper.x.tickOrientation.nonEditable"
      v-model="internalValue.AxisHelper.x.tickOrientation.value"
      title="chart_x_axis"
      :options="toggleOptions.axisX"
    />
    <ToggleOptionsInput 
      v-if="internalValue.AxisHelper && !internalValue.AxisHelper.y.tickOrientation.nonEditable"
      v-model="internalValue.AxisHelper.y.tickOrientation.value"
      title="chart_y_axis"
      :options="toggleOptions.axisY"
    />
    <CheckboxInput 
      v-if="internalValue.AxisHelper && internalValue.AxisHelper.y.normalized"
      v-model="internalValue.AxisHelper.y.normalized.value"
      text="normalize_axes"
    />
    
    <ColorScaleInput
      v-if="chartId==='heat-map' || chartId==='tree-map'"
      v-model="internalValue.ItemsHelper.colorScale.value"
      :allow-categorical="chartId==='tree-map'"
      :all-time-values="allTimeValues"
      :transparency-enabled="false"
    />
  </div>
</template>

<script>
import CheckboxInput from './CheckboxInput.vue'
import ToggleOptionsInput from './ToggleOptionsInput.vue'
import ColorScaleInput from '../maps/ColorScaleInput.vue'
export default {
  components: { CheckboxInput, ToggleOptionsInput, ColorScaleInput },
  model: {
    prop: 'config',
    event: 'change',
  },
  props: {
    config: Object,
    chartId: String,
    allTimeValues: Array,
  },
  data() {
    return {
      showLinePoints: true,
      specialDonutCheckbox: false,
      internalValue: null,
      toggleOptions: {
        orientation: [
          {
            label: 'chart_horizontal',
            value: true,
            icon: 'horizontal',
          },
          {
            label: 'chart_vertical',
            value: false,
            icon: 'vertical',
          },
        ],
        lineAppearence: [
          {
            label: 'chart_line_round',
            value: 'smooth',
            icon: 'corner-bezier',
          },
          {
            label: 'chart_line_rect',
            value: 'sharp',
            icon: 'corner-sharp',
          },
        ],
        color: [
          {
            label: 'chart_categorical',
            value: 'categorical',
          },
          {
            label: 'chart_unicolor',
            value: 'single',
          },
        ],
        axisX: [
          {
            value: 'horizontal',
            icon: 'horizontal-axis',
          },
          {
            value: 'vertical',
            icon: 'vertical-axis',
          },
          {
            value: 'skewed',
            icon: 'skewed-axis',
          },
        ],
        axisY: [
          {
            value: 'horizontal',
            icon: 'horizontal-axis',
          },
          {
            value: 'vertical',
            icon: 'vertical-axis',
          },
          {
            value: 'skewed',
            icon: 'skewed-axis',
          },
        ],
      },
    }
  },
  computed: {},
  watch: {
    showLinePoints() {
      if (this.showLinePoints) this.internalValue.pointsSize.value = 2
      else this.internalValue.pointsSize.value = 0
    },
    config: {
      handler(value) {
        let tmp = { ...value }
        this.internalValue = tmp
      },
      immediate: true,
    },
    internalValue: {
      handler(value) {
        if (JSON.stringify(value) !== JSON.stringify(this.config)) this.$emit('change', value)
      },
      deep: true,
    },
    specialDonutCheckbox() {
      if (this.specialDonutCheckbox) {
        this.internalValue.labelValue.value = 'abs'
      } else this.internalValue.labelValue.value = 'none'
    },
  },
}
</script>

<style lang="stylus" scoped>
.chart-config
  padding: vw(10px) vw(20px)
  background: #fff

  .checkbox-points
    margin-bottom: vw(10px)

  .mobile &
    padding: vw(10px) vw(30px)

  .legend-wrap
    margin-bottom: vw(10px)

    .title
      m-font-size(14, 20)
      margin-bottom: vw(10px)
      font-weight: 600

    .checkboxes-wrap
      display: flex
      flex-direction: column
      gap: vw(5px)
</style>
